module.exports = __webpack_public_path__ + "img/news-left.f06e2a9.png";